module.exports = __webpack_public_path__ + "img/light-source.59d37df.svg";